import { gql, useLazyQuery, useMutation } from "@outschool/ui-apollo";

const GENERATE_AVATAR_MUTATION = gql`
  mutation GenerateAvatar($animalNames: [String!]!) {
    generateAvatar(animalNames: $animalNames) {
      name
      description
      imageUrl
    }
  }
`;

export function useGenerateAvatarMutation() {
  return useMutation(GENERATE_AVATAR_MUTATION);
}

const SAVE_AVATAR_MUTATION = gql`
  mutation SaveAvatar(
    $imageCdnUrl: String!
    $name: String!
    $description: String!
    $animals: [String!]!
  ) {
    saveAvatar(
      imageCdnUrl: $imageCdnUrl
      name: $name
      description: $description
      animals: $animals
    ) {
      uid
      learnerUid
      attachmentUid
      description
      animals
      createdAt
    }
  }
`;

export function useSaveAvatarMutation() {
  return useMutation(SAVE_AVATAR_MUTATION);
}

const CLEAR_AVATARS_MUTATION = gql`
  mutation ClearAvatars {
    clearAvatars
  }
`;

export function useClearAvatarsMutation() {
  return useMutation(CLEAR_AVATARS_MUTATION);
}

// Client-side polling hooks
const START_AVATAR_GENERATION_MUTATION = gql`
  mutation StartAvatarGeneration($animalNames: [String!]!) {
    startAvatarGeneration(animalNames: $animalNames) {
      generationId
      name
      description
    }
  }
`;

export function useStartAvatarGenerationMutation() {
  return useMutation(START_AVATAR_GENERATION_MUTATION);
}

const CHECK_AVATAR_GENERATION_QUERY = gql`
  query CheckAvatarGeneration(
    $generationId: String!
    $avatarName: String!
    $animalNames: [String!]!
  ) {
    checkAvatarGeneration(
      generationId: $generationId
      avatarName: $avatarName
      animalNames: $animalNames
    ) {
      status
      imageUrl
    }
  }
`;

export const POLLING_INTERVAL_MS = 2000;

export function useCheckAvatarGenerationQuery() {
  return useLazyQuery(CHECK_AVATAR_GENERATION_QUERY, {
    fetchPolicy: "network-only",
  });
}
